const stats = [
  { value: '200+', suffix: '', label: 'Toneladas Importadas' },
  { value: '4', suffix: '', label: 'Campos Petroleros Aprobados' },
  { value: '2022', suffix: '', label: 'Inicio de Operaciones' },
  { value: '100', suffix: '%', label: 'Producto Ya Formulado' },
];

const industries = [
  'Demulsificación de Crudo Pesado',
  'Demulsificación de Crudo Extrapesado',
  'Faja Petrolífera del Orinoco',
  'Campos Ayacucho y Carabobo',
  'Campos Junín y Boyacá',
  'Contratos de Servicio PDVSA',
];

export default function StatsSection() {
  return (
    <section className="relative bg-background-50 py-20 md:py-28 overflow-hidden">
      {/* Subtle pattern overlay */}
      <div className="absolute inset-0 opacity-[0.03]"
        style={{
          backgroundImage: 'radial-gradient(circle at 1px 1px, rgba(0,0,0,0.15) 1px, transparent 0)',
          backgroundSize: '32px 32px',
        }}
      ></div>

      <div className="relative z-10 w-full px-4 md:px-8 lg:px-16">
        <div className="max-w-7xl mx-auto">
          {/* Stats row */}
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-10 mb-16">
            {stats.map((stat) => (
              <div key={stat.label} className="text-center">
                <div className="font-heading text-2xl sm:text-3xl md:text-5xl font-bold text-foreground-950 mb-2 break-words">
                  {stat.value}
                  <span className="text-primary-500">{stat.suffix}</span>
                </div>
                <p className="text-foreground-500 text-xs md:text-sm">{stat.label}</p>
              </div>
            ))}
          </div>

          {/* Divider */}
          <div className="border-t border-background-200/60 my-12"></div>

          {/* Industries served */}
          <div className="text-center">
            <p className="text-foreground-500 text-xs md:text-sm font-medium mb-6 tracking-wide uppercase">
              Especialización
            </p>
            <div className="flex flex-wrap items-center justify-center gap-2 md:gap-3">
              {industries.map((ind) => (
                <span
                  key={ind}
                  className="px-3 md:px-4 py-2 rounded-full bg-background-100 text-foreground-600 text-xs md:text-sm font-medium border border-background-200/60"
                >
                  {ind}
                </span>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}